export function toNumber(value: string): number {
  const n = Number.parseFloat(value)
  return Number.isFinite(n) && n >= 0 ? n : 0
}

export function formatCurrency(value: number): string {
  if (!Number.isFinite(value)) return '$0.00'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
  }).format(value)
}

export function formatCurrencyRounded(value: number): string {
  if (!Number.isFinite(value)) return '$0'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value)
}

export function formatRatio(value: number): string {
  if (!Number.isFinite(value)) return '0.00x'
  return `${value.toFixed(2)}x`
}

export function formatPercent(value: number, decimals = 0): string {
  if (!Number.isFinite(value)) return '0%'
  return `${value.toFixed(decimals)}%`
}

/** Safe division that returns 0 instead of Infinity/NaN when denominator is 0 */
export function safeDivide(numerator: number, denominator: number): number {
  if (!denominator || !Number.isFinite(numerator) || !Number.isFinite(denominator)) return 0
  return numerator / denominator
}
